import { c as _c } from "react/compiler-runtime";
import type { ReactNode, Ref } from 'react';
import { useTranslation } from 'react-i18next';
import { Subsection as SubsectionBody } from '@/components/entity-onboarding-details';
import type { WithEntityProps } from '@/entity/components/with-entity';
import useCurrentEntityDuplicateData from '@/entity/hooks/use-current-entity-duplicate-data';
import DeviceInsights from '../../../device-insights';
import DuplicateData from '../../../duplicate-data';
import OtherInsights from '../../../other-insights';
import type { SectionKey } from '../../onboardings.types';
import OnboardingSection, { SECTION_ICONS } from '../onboarding-section';
type CurrentSection = {
  key: Extract<SectionKey, 'duplicate-data' | 'device-insights' | 'other-insights'>;
  title: string;
  count?: number;
  content: ReactNode;
};
type CurrentDataProps = WithEntityProps & {
  sectionRef?: (key: SectionKey) => Ref<HTMLElement>;
};

/** The live side of the sections an onboarding shows as of its finish: today's dupes, every device, consolidated insights. */
const CurrentData = t0 => {
  const $ = _c(5);
  const {
    entity,
    sectionRef
  } = t0;
  const {
    t
  } = useTranslation("entity-details");
  const isPerson = entity.kind === "person";
  const {
    data: dupes
  } = useCurrentEntityDuplicateData(undefined, isPerson);
  let t1;
  if ($[0] !== dupes?.data || $[1] !== isPerson || $[2] !== sectionRef || $[3] !== t) {
    const sections = [...(isPerson ? [{
      key: "duplicate-data" as const,
      title: t(_temp),
      count: dupes?.data.length || undefined,
      content: <SubsectionBody><DuplicateData /></SubsectionBody>
    }] : []), {
      key: "device-insights",
      title: t(_temp2),
      content: <div className="p-5"><DeviceInsights /></div>
    }, {
      key: "other-insights",
      title: t(_temp3),
      content: <SubsectionBody><OtherInsights /></SubsectionBody>
    }];
    t1 = <div className="flex flex-col gap-8 px-5 pb-6">{sections.map(t2 => {
        const {
          key,
          title,
          count,
          content
        } = t2;
        return <OnboardingSection key={key} ref={sectionRef?.(key)} title={title} icon={SECTION_ICONS[key]} count={count ? {
          count
        } : undefined}>{content}</OnboardingSection>;
      })}</div>;
    $[0] = dupes?.data;
    $[1] = isPerson;
    $[2] = sectionRef;
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
export default CurrentData;
function _temp($) {
  return $.onboardings.tabs.duplicates;
}
function _temp2($_0) {
  return $_0.onboardings.tabs.devices;
}
function _temp3($_1) {
  return $_1.otherInsights.title;
}